module.exports = __webpack_public_path__ + "fonts/SFUIText-Regular.8aa25e34.woff";